<template>
  <div class="timeline-item">
    <!-- Header: Icon and Title -->
    <div class="timeline-header d-flex align-items-center gap-3">
      <div
        class="timeline-icon d-flex align-items-center justify-content-center"
      >
        <div
          class="icon-item icon-item-sm rounded-circle border border-primary d-flex align-items-center justify-content-center"
        >
          <span class="text-primary fw-bolder tabular-nums lh-1">
            <slot name="icon" />
          </span>
        </div>
      </div>
      <div class="timeline-title flex-grow-1 d-flex align-items-center">
        <h5 class="text-primary text-uppercase fw-bolder mb-0">
          {{ title }}
        </h5>
        <div v-if="actions?.length" class="actions-container">
          <button
            v-for="action in actions"
            :key="action.label"
            :class="getButtonClasses(action)"
            @click="action.onClick"
          >
            <font-awesome-icon
              v-if="action.icon"
              :icon="action.icon"
              class="me-1"
              size="xs"
            />
            {{ action.label }}
          </button>
        </div>
      </div>
    </div>

    <!-- Content: Timeline Bar and Content -->
    <div class="timeline-content d-flex gap-3">
      <div class="timeline-bar-container d-flex justify-content-center">
        <div class="timeline-bar border-start border-dashed"></div>
      </div>
      <div class="timeline-content-area flex-grow-1 pb-5 pt-3">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface ActionButton {
  label: string;
  icon?: string;
  variant?: string;
  onClick: () => void;
}

defineProps<{
  title: string;
  actions?: ActionButton[];
}>();

const getButtonClasses = (action: ActionButton) => {
  const baseClasses = "btn d-inline-flex align-items-center";
  const variantClasses =
    action.variant || "btn-sm btn-subtle-primary py-1 px-2 fs-9";
  return `${baseClasses} ${variantClasses}`;
};
</script>

<style scoped lang="scss">
.timeline-icon {
  width: 40px; /* Fixed width to align with icon size */
  flex-shrink: 0;
}

.timeline-bar-container {
  width: 40px; /* Same width as icon to maintain alignment */
  flex-shrink: 0;
}

.timeline-bar {
  width: 1px;
  min-height: 100%;
}
</style>
